import { render, staticRenderFns } from "./QaSheet.vue?vue&type=template&id=2fa8df5e&scoped=true"
import script from "./QaSheet.vue?vue&type=script&lang=js"
export * from "./QaSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa8df5e",
  null
  
)

export default component.exports